
import Vue from 'vue'
import Component, { mixins } from 'vue-class-component'
import mixin from '@/mixin'
import { db } from '@/main'
import CreateAdminDialog from '@/components/admins/createAdmin.vue'
import DeleteAdmin from '@/components/admins/deleteAdmin.vue'

@Component({
  components: {
    CreateAdminDialog,
    DeleteAdmin,
  },
})
export default class Admin extends mixins(mixin) {
  adminsList: any = []
  search = ''

  headers = [
    {
      text: 'Foto',
      value: 'profile_info.image',
      sortable: false,
      width: '40px',
    },
    { text: 'Nombres', value: 'profile_info.names' },
    { text: 'Apellidos', value: 'profile_info.last_names' },
    { text: 'Email', value: 'profile_info.email' },
    { text: 'Acciones', value: 'actions', sortable: false },
  ]

  mounted() {
    db.collection('admins').onSnapshot((querySnapshot) => {
      this.adminsList = []
      querySnapshot.forEach((doc) => {
        const adminData = doc.data()
        adminData['uid'] = doc.id
        this.adminsList.push(adminData)
      })
    })
  }
}
